import {
	matchPath,
} from 'react-router-dom'

import {
	MAIN_PAGES,
} from '../config'

export const isMainPage = (pathname: string): boolean => {
	return MAIN_PAGES.some((pattern) => {
		return matchPath(pattern, pathname)
	})
}
